import { render, staticRenderFns } from "./My_money.vue?vue&type=template&id=4806b044&scoped=true&"
import script from "./My_money.vue?vue&type=script&lang=js&"
export * from "./My_money.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4806b044",
  null
  
)

export default component.exports